/* Roomberry Lampenschirm-Vorlage v5 (rb-lsp) — Seitenlogik.
   Kein Fremdcode, kein lazysizes-Zugriff, kein Intervall. Wache gegen doppeltes Laden. */
(function () {
  'use strict';
  if (window.RBLsp) { return; }
  window.RBLsp = true;

  function alle(sel, wurzel) { return Array.prototype.slice.call((wurzel || document).querySelectorAll(sel)); }
  /* „Bewegung reduzieren“ live mitlesen — wer die Einstellung bei offener Seite ändert, bekommt sie sofort */
  var bewegungMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduziert = !!(bewegungMq && bewegungMq.matches);
  if (bewegungMq) {
    var bewegungNeu = function (e) { reduziert = !!e.matches; };
    if (bewegungMq.addEventListener) { bewegungMq.addEventListener('change', bewegungNeu); } else if (bewegungMq.addListener) { bewegungMq.addListener(bewegungNeu); }
  }

  /* Varianten-Insel aus rb-lsp-sticky: { id: { t, p, b } } */
  var insel = null;
  function varianten() {
    if (insel) { return insel; }
    var el = document.querySelector('script[data-rb-lsp-varianten]');
    try { insel = el ? JSON.parse(el.textContent) : {}; } catch (e) { insel = {}; }
    return insel;
  }
  /* Optionsnamen (z. B. ["Farbe","Größe"]) stehen am Insel-Tag, die Werte je Variante in o */
  var namen = null;
  function optionsNamen() {
    if (namen) { return namen; }
    var el = document.querySelector('script[data-rb-lsp-varianten]');
    try { namen = el ? JSON.parse(el.getAttribute('data-rb-optionen') || '[]') : []; } catch (e) { namen = []; }
    return namen;
  }
  function wertVon(v, name) {
    var i = optionsNamen().indexOf(name);
    if (v && v.o && i > -1) { return v.o[i]; }
    /* Rückfall ohne Namen: Titel „Farbe / Größe“ */
    var teile = String(v ? v.t : '').split(' / ');
    return name === 'Farbe' ? teile[0] : teile[teile.length - 1];
  }
  /* Zuerst das Kaufformular der Produktseite (Selektor wie conrise application.js Z. 2136). Der
     Warenkorb-Drawer steht im DOM VOR dem Seiteninhalt und kann ein Upsell-Formular mit /cart/add und
     input[name=id] tragen (cart-drawer.liquid Z. 586 ff.) — das darf nie das Feld sein. */
  function idFeld() {
    return document.querySelector('#product-add-to-cart-form input[name="id"]')
      || document.querySelector('form[action^="/cart/add"]:not(#cart-upselling) input[name="id"]')
      || document.querySelector('form[action*="/cart/add"]:not(#cart-upselling) input[name="id"]');
  }
  function kaufFormular() { var f = idFeld(); return f ? f.form : null; }

  /* Preis, Variantenname, Bild und aktive Größe nachziehen */
  function zeichne() {
    var feld = idFeld();
    if (!feld) { return; }
    var v = varianten()[feld.value];
    if (!v) { return; }
    alle('[data-rb-sticky-preis]').forEach(function (el) { el.textContent = v.p; });
    alle('[data-rb-sticky-var]').forEach(function (el) { el.textContent = v.t; });
    alle('[data-rb-sticky-bild]').forEach(function (el) { if (v.b && el.getAttribute('src') !== v.b) { el.src = v.b; } });
    farbeFolgen(wertVon(v, 'Farbe'));
    var groesse = wertVon(v, 'Größe');
    alle('[data-rb-nur-groesse]').forEach(function (el) {
      el.hidden = el.getAttribute('data-rb-nur-groesse') !== groesse;
    });
    alle('[data-rb-groessenwahl]').forEach(function (wahl) { groessenZeichnen(wahl, v); });
    mwstZeichnen(v);
  }

  /* Versandzeile am Preis: Schwelle + Versand live aus dem Warenkorb-Drawer (wie snippets/versand-info) */
  function centAttr(attr) {
    var el = document.querySelector('.cart-drawer-footer[' + attr + ']') || document.querySelector('[' + attr + ']');
    var n = el ? parseInt(el.getAttribute(attr), 10) : NaN;
    return n > 0 ? n : null;
  }
  function euro(c, kurz) {
    var s = (c / 100).toFixed(2).replace('.', ',');
    return (kurz && s.slice(-3) === ',00' ? s.slice(0, -3) : s) + ' €';
  }
  function mwstZeichnen(v) {
    if (!v || typeof v.c !== 'number') { return; }
    alle('[data-rb-mwst]').forEach(function (el) {
      var schwelle = centAttr('data-free-shipping-order-value') || parseInt(el.getAttribute('data-schwelle'), 10);
      var versand = centAttr('data-delivery-costs') || parseInt(el.getAttribute('data-versand'), 10);
      el.textContent = v.c >= schwelle
        ? 'inkl. MwSt. · versandkostenfrei'
        : 'inkl. MwSt. · zzgl. ' + euro(versand) + ' Versand – versandkostenfrei ab ' + euro(schwelle, true);
    });
  }

  /* Größenkarten = Größenwahl (Runde 3). Zustand folgt immer der echten Variante des Themes. */
  function kombination(v, pos, wert) {
    if (!v || !v.o) { return null; }
    var alleV = varianten();
    for (var id in alleV) {
      if (!Object.prototype.hasOwnProperty.call(alleV, id)) { continue; }
      var o = alleV[id].o;
      if (!o || o[pos] !== wert) { continue; }
      var passt = true;
      for (var i = 0; i < o.length; i += 1) { if (i !== pos && o[i] !== v.o[i]) { passt = false; break; } }
      if (passt) { return alleV[id]; }
    }
    return null;
  }
  function groessenZeichnen(wahl, v) {
    var name = wahl.getAttribute('data-rb-option') || 'Größe';
    var pos = parseInt(wahl.getAttribute('data-rb-pos'), 10);
    var jetzt = wertVon(v, name);
    alle('[data-rb-groesse-wert]', wahl).forEach(function (el) { el.textContent = jetzt; });
    alle('[data-rb-groesse]', wahl).forEach(function (karte) {
      var wert = karte.getAttribute('data-rb-groesse');
      karte.setAttribute('aria-pressed', wert === jetzt ? 'true' : 'false');
      var k = isNaN(pos) ? null : kombination(v, pos, wert);
      var aus = !!(v.o && (!k || k.a === false));
      if (aus) { karte.setAttribute('aria-disabled', 'true'); } else { karte.removeAttribute('aria-disabled'); }
      var hinweis = karte.querySelector('[data-rb-g-aus]');
      if (hinweis) { hinweis.hidden = !aus; }
      if (k) {
        var pr = karte.querySelector('[data-rb-g-preis]');
        var st = karte.querySelector('[data-rb-g-streich]');
        if (pr) { pr.textContent = k.p; }
        if (st) { st.textContent = k.k || ''; st.hidden = !k.k; }
      }
    });
  }

  /* Optionswert im Theme setzen — Klick auf die Hülle des Radios (Muster setzeWert, Pilzwald-Seite):
     Das Theme hängt seinen Handler an .product-information-variant-picker-button-variant-option, nicht
     an das Radio; ein Klick auf das nackte Radio ließe Preis und Varianten-ID stehen. */
  /* Nur Radios/Auswahl im Kaufformular — nie die eines Upsell-Formulars im Drawer */
  function imKaufformular(el) { var f = kaufFormular(); return !f || f.contains(el); }
  function themeRadios(name) {
    return alle('input.product-variant-radio').filter(function (r) { return r.name === name && imKaufformular(r); });
  }
  function themeAuswahl(name) {
    return alle('select.product-variant-select').filter(function (s) { return s.name === name && imKaufformular(s); })[0] || null;
  }
  function setzeWert(name, wert) {
    var radios = themeRadios(name);
    for (var i = 0; i < radios.length; i += 1) {
      if (radios[i].value === wert) {
        if (!radios[i].checked) {
          var huelle = radios[i].closest ? radios[i].closest('.product-information-variant-picker-button-variant-option') : null;
          if (huelle) { huelle.click(); } else { radios[i].click(); }
        }
        return true;
      }
    }
    var auswahl = themeAuswahl(name);
    if (auswahl) {
      for (var j = 0; j < auswahl.options.length; j += 1) {
        if (auswahl.options[j].value === wert) {
          auswahl.selectedIndex = j;
          auswahl.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }
  /* Die Theme-Gruppe „Größe“ verschwindet erst, wenn die Karten nachweislich schalten können:
     Radios bzw. Auswahl gefunden, Formular-ID gefunden, Varianten-Insel gelesen. Sonst bleibt sie. */
  function groessenwahl() {
    alle('[data-rb-groessenwahl]').forEach(function (wahl) {
      if (wahl.getAttribute('data-rb-bereit') === 'ja') { return; }
      var name = wahl.getAttribute('data-rb-option') || 'Größe';
      var radios = themeRadios(name);
      var auswahl = themeAuswahl(name);
      var gruppe = radios.length
        ? radios[0].closest('.product-information-variant-picker-button-variant')
        : (auswahl ? auswahl.closest('.product-information-variant-picker-dropdown-variant') : null);
      var karten = alle('[data-rb-groesse]', wahl);
      if (!gruppe || !idFeld() || !karten.length || !Object.keys(varianten()).length) { return; }
      /* Gruppe und Varianten-ID müssen im selben Formular stehen, sonst schalten die Karten ins Leere */
      if (gruppe.closest('form') !== kaufFormular()) { return; }
      var werte = radios.length ? radios.map(function (r) { return r.value; })
        : Array.prototype.map.call(auswahl.options, function (o) { return o.value; });
      if (!karten.every(function (k) { return werte.indexOf(k.getAttribute('data-rb-groesse')) > -1; })) { return; }
      wahl.setAttribute('data-rb-bereit', 'ja');
      karten.forEach(function (karte) {
        karte.addEventListener('click', function (ev) {
          ev.preventDefault();
          wahl.setAttribute('data-rb-getippt', 'ja');
          if (karte.getAttribute('aria-disabled') === 'true') { return; }
          setzeWert(name, karte.getAttribute('data-rb-groesse'));
          window.requestAnimationFrame(zeichne);
        });
      });
      gruppe.classList.add('rb-lsp-theme-aus');
      /* Karten sichtbar schalten (html.rb-g-js, gesetzt inline in rb-lsp-kaufbox) — auch dann, wenn der
         Rückfall-Timer die Klasse bei langsamem Laden schon entfernt hatte. */
      document.documentElement.classList.add('rb-g-js');
      gruppe.setAttribute('data-rb-ersetzt', 'Größenkarten');
      alle('[data-rb-g-label]', wahl).forEach(function (el) { el.hidden = false; });
      wahl.classList.add('rb-lsp-box__groessenwahl--aktiv');
      /* Bugfix E2: Tipp aus der Zeit vor der Kopplung nachholen (gemerkt vom Inline-Script in rb-sch-kaufbox) */
      if (window.__rbGFrueh) {
        var frueh = window.__rbGFrueh; window.__rbGFrueh = null;
        if (karten.some(function (k) { return k.getAttribute('data-rb-groesse') === frueh; })) {
          /* Nachbesserung 14.10. 21:2x: Beim ersten Koppeln hängen die Theme-Handler oft noch nicht — deshalb
             nachholen, bis die Theme-Variante passt; nie, wenn danach selbst eine Karte getippt wurde. */
          var nachholen = function () {
            if (wahl.getAttribute('data-rb-getippt') === 'ja') { return; }
            var r = themeRadios(name).filter(function (x) { return x.checked; })[0];
            var a = themeAuswahl(name);
            var ist = r ? r.value : (a ? a.value : null);
            if (ist !== frueh) { setzeWert(name, frueh); }
            window.requestAnimationFrame(zeichne);
          };
          nachholen();
          if (document.readyState !== 'complete') { window.addEventListener('load', function () { window.setTimeout(nachholen, 60); }); }
          window.setTimeout(nachholen, 1200);
        }
      }
    });
  }

  /* Das Theme meldet den Variantenwechsel nicht per Event, es schreibt nur das Attribut value
     von input[name=id] (geprüft 22.09. an der Pilzwald-Seite). Darauf hängt der Beobachter. */
  var beobachtet = null;
  function beobachte() {
    var feld = idFeld();
    if (!feld || !window.MutationObserver) { return false; }
    if (feld === beobachtet) { return true; }
    beobachtet = feld;
    new MutationObserver(zeichne).observe(feld, { attributes: true, attributeFilter: ['value'] });
    return true;
  }

  /* Zweite Kaufknöpfe klicken den echten Kaufknopf des Themes */
  function kaufen() {
    var knopf = document.querySelector('.product-information-buy-buttons button[type="submit"]')
      || document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    if (knopf) { knopf.click(); return true; }
    return false;
  }
  document.addEventListener('click', function (ev) {
    var ziel = ev.target.closest ? ev.target.closest('[data-rb-kaufen]') : null;
    if (!ziel) { return; }
    ev.preventDefault();
    if (!kaufen()) {
      var box = document.querySelector('.product-information-buy-buttons');
      if (box) { box.scrollIntoView({ behavior: reduziert ? 'auto' : 'smooth', block: 'center' }); }
    }
  });

  /* Schwebeleiste erst, wenn der echte Kaufknopf oberhalb aus dem Bild ist */
  function schwebeleiste() {
    alle('[data-rb-sticky]').forEach(function (leiste) {
      if (leiste.getAttribute('data-rb-bereit') === 'ja') { return; }
      var anker = document.querySelector(leiste.getAttribute('data-rb-ab') || '.product-information-buy-buttons');
      if (!anker || !window.IntersectionObserver) { return; }
      leiste.setAttribute('data-rb-bereit', 'ja');
      /* Nie zwei „In den Warenkorb“ übereinander: Ist das Kaufband im Bild, tritt die Leiste zurück. */
      var obenSichtbar = true;
      var bandSichtbar = false;
      function setze() { leiste.hidden = obenSichtbar || bandSichtbar; }
      new IntersectionObserver(function (e) {
        e.forEach(function (x) { obenSichtbar = x.isIntersecting || x.boundingClientRect.top > 0; });
        setze();
      }, { threshold: 0 }).observe(anker);
      alle('.rb-lsp-kaufband').forEach(function (band) {
        new IntersectionObserver(function (e) {
          e.forEach(function (x) { bandSichtbar = x.isIntersecting; });
          setze();
        }, { threshold: 0.25 }).observe(band);
      });
    });
  }

  /* Licht an/aus je Farbe: Farb-Knöpfe zeigen das Paar der Farbe, der Schalter (fester Name „Licht“,
     Zustand über aria-checked bei role="switch", sonst aria-pressed) blendet zwischen aus und an — für alle
     Paare gemeinsam. Einmal selbst einschalten nur mit data-auto="ja", nie bei reduzierter Bewegung, nie nach
     einem Klick der Kundin.
     Runde 2 Schirme (27.09., Onda/Riga mit vier Farben):
     · Farbwechsel ohne leere Fläche: Ist das Bild der neuen Farbe noch nicht geladen, bleibt das alte Paar
       stehen, bis es da ist (höchstens 600 ms). Der Knopf zeigt die Wahl sofort.
     · Vorladen gestaffelt: naht die Bühne, zuerst das gezeigte Paar (aus + an, fürs erste Einschalten), die
       übrigen Farben im Leerlauf; mit „Datensparmodus“ nur bei Absicht (Zeiger/Fokus auf einem Farb-Knopf).
     · data-kaufwahl="ja": Farb-Knopf wählt die Farbe auch in der Kaufbox (setzeWert wie die Größenkarten).
     · Screenreader: das verdeckte Bild eines Paares ist aria-hidden; Pfeiltasten springen zwischen Farb-Knöpfen. */
  function lichtPaare(sek) { return alle('.rb-lsp-licht__paar', sek); }
  function lichtPaar(sek, farbe) {
    return lichtPaare(sek).filter(function (p) { return p.getAttribute('data-rb-farbe') === farbe; })[0] || null;
  }
  function lichtEager(paar) {
    if (!paar) { return; }
    alle('img', paar).forEach(function (i) { if (i.loading !== 'eager') { i.loading = 'eager'; } });
  }
  function lichtIstAn(sek) {
    var buehne = sek.querySelector('[data-rb-licht]');
    return !!buehne && buehne.getAttribute('data-licht') === 'an';
  }
  function bildDa(img) { return !img || (img.complete && img.naturalWidth > 0); }
  function lichtBildRollen(sek) {
    var an = lichtIstAn(sek);
    lichtPaare(sek).forEach(function (p) {
      var bAus = p.querySelector('.rb-lsp-licht__aus');
      var bAn = p.querySelector('.rb-lsp-licht__an');
      if (bAus) { if (an) { bAus.setAttribute('aria-hidden', 'true'); } else { bAus.removeAttribute('aria-hidden'); } }
      if (bAn) { if (an) { bAn.removeAttribute('aria-hidden'); } else { bAn.setAttribute('aria-hidden', 'true'); } }
    });
  }
  function zeigeFarbe(sek, farbe) {
    var ziel = lichtPaar(sek, farbe);
    if (!ziel) { return false; }
    alle('[data-rb-farbe-knopf]', sek).forEach(function (k) {
      k.setAttribute('aria-pressed', k.getAttribute('data-rb-farbe-knopf') === farbe ? 'true' : 'false');
    });
    var buehne = sek.querySelector('[data-rb-licht]');
    sek.setAttribute('data-rb-ziel', farbe);
    function tausche() {
      if (sek.getAttribute('data-rb-ziel') !== farbe) { return; } /* inzwischen andere Farbe gewählt */
      lichtPaare(sek).forEach(function (p) { p.hidden = p !== ziel; });
      if (buehne) { buehne.removeAttribute('data-rb-laedt'); }
    }
    /* Bühne noch fern: nur umschalten, loading="lazy" lädt, wenn sie naht (kein Vorabladen aus der Kaufbox) */
    if (!ziel.hidden || sek.getAttribute('data-rb-nah') !== 'ja') { tausche(); return true; }
    lichtEager(ziel);
    var bild = ziel.querySelector(lichtIstAn(sek) ? '.rb-lsp-licht__an' : '.rb-lsp-licht__aus');
    if (bildDa(bild)) { tausche(); return true; }
    if (buehne) { buehne.setAttribute('data-rb-laedt', 'ja'); }
    var fertig = false;
    function einmal() { if (!fertig) { fertig = true; tausche(); } }
    bild.addEventListener('load', einmal, { once: true });
    bild.addEventListener('error', einmal, { once: true });
    window.setTimeout(einmal, 600);
    return true;
  }
  function anBildSichtbar(sek) {
    var paar = lichtPaare(sek).filter(function (p) { return !p.hidden; })[0];
    return paar ? paar.querySelector('.rb-lsp-licht__an') : null;
  }
  function datenSparen() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(c && c.saveData);
  }
  function licht() {
    alle('.rb-lsp-licht').forEach(function (sek) {
      var buehne = sek.querySelector('[data-rb-licht]');
      var knopf = sek.querySelector('[data-rb-schalter]');
      var text = sek.querySelector('[data-rb-schalter-text]');
      if (!buehne || !knopf || knopf.getAttribute('data-rb-bereit') === 'ja') { return; }
      knopf.setAttribute('data-rb-bereit', 'ja');
      var huelle = sek.closest('[data-rb-licht-huelle]');
      /* role="switch" → aria-checked; ältere Auszeichnung (Knopf mit aria-pressed) läuft weiter */
      var zustandAttr = knopf.getAttribute('role') === 'switch' ? 'aria-checked' : 'aria-pressed';
      var marke = buehne.querySelector('[data-rb-marke]'); /* 07.10.: Etikett im Bild ist ein echter Knopf (aria-pressed) */
      function setze(an) {
        buehne.setAttribute('data-licht', an ? 'an' : 'aus');
        if (huelle) { huelle.setAttribute('data-licht', an ? 'an' : 'aus'); }
        knopf.setAttribute(zustandAttr, an ? 'true' : 'false');
        if (marke) { marke.setAttribute('aria-pressed', an ? 'true' : 'false'); }
        if (text) { text.textContent = an ? 'ausschalten' : 'einschalten'; }
        lichtBildRollen(sek);
      }
      lichtBildRollen(sek);
      knopf.addEventListener('click', function () {
        buehne.setAttribute('data-rb-auto', 'fertig');
        setze(buehne.getAttribute('data-licht') !== 'an');
      });
      /* 07.10.: Tippen auf das große Bild oder das Etikett schaltet das Licht (statt Zoom — Kundinnen tippen ins Bild).
         Läuft über knopf.click(): Zustand, Auto-Sperre und Messung (rb_licht_schalter) genau wie beim Schalter. */
      buehne.addEventListener('click', function (ev) {
        if (!ev.target.closest || !ev.target.closest('.rb-lsp-licht__paar, [data-rb-marke]')) { return; }
        ev.preventDefault();
        knopf.click();
      });
      var farbKnoepfe = alle('[data-rb-farbe-knopf]', sek);
      farbKnoepfe.forEach(function (k, i) {
        var farbe = k.getAttribute('data-rb-farbe-knopf');
        k.addEventListener('click', function () {
          zeigeFarbe(sek, farbe);
          /* Beide Richtungen gekoppelt: Kaufbox auf dieselbe Farbe. Der Beobachter am id-Feld ruft danach
             zeichne() → farbeFolgen(): Größe-Bild, Kaufband und Leiste ziehen mit, die Bühne bleibt. */
          if (buehne.getAttribute('data-kaufwahl') === 'ja' && setzeWert('Farbe', farbe)) {
            window.requestAnimationFrame(zeichne);
          }
        });
        /* Absicht erkennen: Zeiger oder Fokus auf dem Knopf → dieses Paar sofort laden */
        function absicht() { if (sek.getAttribute('data-rb-nah') === 'ja' || datenSparen()) { lichtEager(lichtPaar(sek, farbe)); } }
        k.addEventListener('pointerenter', absicht);
        k.addEventListener('focus', absicht);
        k.addEventListener('touchstart', absicht, { passive: true });
        /* Pfeiltasten: Fokus zum nächsten/vorigen Farb-Knopf (Tab bleibt wie gehabt) */
        k.addEventListener('keydown', function (ev) {
          var n = farbKnoepfe.length;
          var ziel = null;
          if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') { ziel = farbKnoepfe[(i + 1) % n]; }
          else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') { ziel = farbKnoepfe[(i - 1 + n) % n]; }
          else if (ev.key === 'Home') { ziel = farbKnoepfe[0]; }
          else if (ev.key === 'End') { ziel = farbKnoepfe[n - 1]; }
          if (ziel) { ev.preventDefault(); ziel.focus(); }
        });
      });
      /* Vorladen gestaffelt, sobald die Bühne naht — sonst bleibt die Fläche beim ersten Tippen auf eine andere
         Farbe mobil 0,3–0,5 s leer (runde3/mobil/mobil.md Befund 4). Gezeigtes Paar zuerst, Rest im Leerlauf. */
      function naht() {
        if (sek.getAttribute('data-rb-nah') === 'ja') { return; }
        sek.setAttribute('data-rb-nah', 'ja');
        var gezeigt = lichtPaare(sek).filter(function (p) { return !p.hidden; })[0];
        lichtEager(gezeigt);
        if (datenSparen()) { return; }
        var rest = function () { lichtPaare(sek).forEach(lichtEager); };
        if (window.requestIdleCallback) { window.requestIdleCallback(rest, { timeout: 1200 }); } else { window.setTimeout(rest, 300); }
      }
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (e, io) {
          e.forEach(function (x) {
            if (!x.isIntersecting) { return; }
            io.disconnect();
            naht();
          });
        }, { rootMargin: '600px 0px' }).observe(buehne);
      } else {
        naht();
      }
      /* Puls statt Auto-Ein (Runde 2), Runde 3: am SCHALTER selbst, erst wenn er ganz und oberhalb der
         Schwebeleiste im Bild ist — mobil liegt er unter der Bühne (mobil.md Befund 2). */
      if (buehne.getAttribute('data-puls') === 'ja' && buehne.getAttribute('data-auto') !== 'ja' && !reduziert && window.IntersectionObserver) { /* 07.10.: bei Auto-Ein kein Puls */
        new IntersectionObserver(function (e, io) {
          e.forEach(function (x) {
            if (!x.isIntersecting) { return; }
            io.disconnect();
            if (!reduziert && buehne.getAttribute('data-licht') !== 'an') { knopf.setAttribute('data-rb-puls', 'an'); }
          });
        }, { threshold: 1, rootMargin: '0px 0px -80px 0px' }).observe(knopf);
        knopf.addEventListener('animationend', function () { knopf.removeAttribute('data-rb-puls'); });
      }
      if (buehne.getAttribute('data-auto') !== 'ja' || reduziert || !window.IntersectionObserver) { return; }
      new IntersectionObserver(function (e, io) {
        e.forEach(function (x) {
          if (!x.isIntersecting) { return; }
          io.disconnect();
          var bild = anBildSichtbar(sek);
          function los() {
            window.setTimeout(function () {
              if (buehne.getAttribute('data-rb-auto') !== 'fertig' && !reduziert) { setze(true); }
            }, 700);
          }
          if (!bild || (bild.complete && bild.naturalWidth > 0)) { los(); return; }
          bild.loading = 'eager';
          bild.addEventListener('load', los, { once: true });
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -15% 0px' }).observe(buehne); /* 07.10. (Benjamin): früher an — 25 % der Bühne über dem unteren Banner-Streifen (≈15 %), dann 700 ms; der Kunde sieht das Licht angehen und scrollt weiter; zählt nicht als Klick */
    });
  }

  /* Farbe der Kaufbox → Bühne. Nur bei echtem Wechsel: Ohne Kopplung (Wave) bleibt eine Farbe, die die Kundin
     in der Bühne gewählt hat, stehen, bis sie in der Kaufbox wirklich eine andere Farbe nimmt. */
  var letzteFarbe = null;
  function farbeFolgen(farbe) {
    if (!farbe || farbe === letzteFarbe) { return; }
    var erstes = letzteFarbe === null;
    letzteFarbe = farbe;
    if (erstes) { return; }
    alle('.rb-lsp-licht').forEach(function (sek) { zeigeFarbe(sek, farbe); });
    alle('[data-rb-farbwechsel]').forEach(function (box) {
      var kinder = alle('[data-rb-farbe]', box);
      if (!kinder.some(function (k) { return k.getAttribute('data-rb-farbe') === farbe; })) { return; }
      alle('img', box).forEach(function (i) { i.loading = 'eager'; });
      kinder.forEach(function (k) { k.hidden = k.getAttribute('data-rb-farbe') !== farbe; });
    });
  }

  /* Bilder der nicht gewählten Farben (Größe-Sektion, Kaufband) vorladen, sobald die Box naht —
     sonst bleibt die Fläche beim ersten Farbwechsel mobil kurz leer (wie Licht, mobil.md Befund 4). */
  function farbwechselVorladen() {
    alle('[data-rb-farbwechsel]').forEach(function (box) {
      if (box.getAttribute('data-rb-bereit') === 'ja') { return; }
      box.setAttribute('data-rb-bereit', 'ja');
      if (!window.IntersectionObserver) { alle('img', box).forEach(function (i) { i.loading = 'eager'; }); return; }
      new IntersectionObserver(function (e, io) {
        e.forEach(function (x) {
          if (!x.isIntersecting) { return; }
          io.disconnect();
          alle('img', box).forEach(function (i) { i.loading = 'eager'; });
        });
      }, { rootMargin: '600px 0px' }).observe(box);
    });
  }

  /* ---------- Zoom (06.10.): Tippen auf ein Bild öffnet es groß ----------
     Clarity 26.09.–05.10.: Onda 11 % Sitzungen mit Klicks ins Leere (Shop 2 %), mobil 15 % — Kundinnen tippen auf
     Galerie- und Sektionsbilder, die nichts tun. Natives <dialog>, kein Fremdcode; Wischen im Slider bleibt Wischen
     (Weg > 8 px oder > 600 ms = kein Tippen). Zweites Tippen im Dialog: 2-fach, scrollbar. Nur v5-Seiten (rb-lsp.js). */
  /* 07.10.: .rb-lsp-licht__paar img raus — Tippen auf die Licht-Bühne schaltet das Licht (licht()) */
  var ZOOM_SEL = '.product-media-main .swiper-slide img, .rb-lsp-bildtext__bild, .rb-lsp-kaufband__img, [data-rb-farbwechsel] img';
  function zoomUrl(img) {
    var u = img.currentSrc || img.src;
    if (!u || u.indexOf('data:') === 0) { return null; }
    if (/[?&]width=\d+/.test(u)) { return u.replace(/([?&])width=\d+/, '$1width=1800'); }
    return u.replace(/_(\d+x\d*|x\d+)(\.[a-z]+)(\?|$)/i, '_1800x$2$3');
  }
  function zoomDialog() {
    var d = document.querySelector('dialog.rb-lsp-zoom');
    if (d) { return d; }
    d = document.createElement('dialog'); d.className = 'rb-lsp-zoom'; d.setAttribute('aria-label', 'Bild vergrößert');
    d.innerHTML = '<button type="button" class="rb-lsp-zoom__zu" aria-label="Schließen">&times;</button><img class="rb-lsp-zoom__bild" alt="" decoding="async">';
    var img = d.querySelector('img');
    d.addEventListener('click', function (ev) {
      if (ev.target === img) { d.classList.toggle('rb-lsp-zoom--gross'); return; }
      d.close();
    });
    d.addEventListener('close', function () {
      d.classList.remove('rb-lsp-zoom--gross'); img.removeAttribute('src');
      document.documentElement.classList.remove('rb-lsp-zoom-offen');
    });
    document.body.appendChild(d);
    return d;
  }
  function zoom() {
    if (!window.HTMLDialogElement || document.documentElement.getAttribute('data-rb-zoom') === 'ja') { return; }
    document.documentElement.setAttribute('data-rb-zoom', 'ja');
    var dx = 0, dy = 0, dt = 0;
    document.addEventListener('pointerdown', function (ev) {
      if (!ev.target.closest || !ev.target.closest(ZOOM_SEL)) { return; }
      dx = ev.clientX; dy = ev.clientY; dt = Date.now();
    }, true);
    document.addEventListener('click', function (ev) {
      var img = ev.target.closest && ev.target.closest(ZOOM_SEL);
      if (!img || img.closest('a, button, dialog')) { return; }
      if (Math.abs(ev.clientX - dx) > 8 || Math.abs(ev.clientY - dy) > 8 || Date.now() - dt > 600) { return; }
      var u = zoomUrl(img);
      if (!u) { return; }
      ev.preventDefault();
      var d = zoomDialog(), z = d.querySelector('img');
      z.alt = img.alt || ''; z.src = u;
      document.documentElement.classList.add('rb-lsp-zoom-offen');
      if (!d.open) { d.showModal(); }
    });
  }

  /* ---------- Kaufleiste über dem Cookie-Banner (07.10.) ----------
     Der Pandectes-Banner (.pd-cookie-banner-window, fixed, z-index 2147483647) deckt die Leiste unten komplett ab, solange
     nicht zugestimmt ist. Solange er unten sichtbar ist, steht seine Höhe in --rb-cookie-h und die Leiste rückt darüber
     (rb-lsp.css); verschwindet er, 0 px. Nur lesend — kein Eingriff in die Cookie-App. Erscheint er später oder wird er
     entfernt: Beobachter auf body (Knoten), am Banner Größe (ResizeObserver) und Klasse/Stil (MutationObserver). */
  var COOKIE_SEL = '.pd-cookie-banner-window';
  function cookieAbstand() {
    var html = document.documentElement;
    if (!document.body || !document.querySelector('[data-rb-sticky]') || html.getAttribute('data-rb-cookie') === 'ja') { return; }
    html.setAttribute('data-rb-cookie', 'ja');
    var banner = null, ro = null, mo = null, plan = 0, letzt = -1;
    function bald() { if (!plan) { plan = window.requestAnimationFrame(messen); } }
    function spaeter() { bald(); window.setTimeout(bald, 700); } /* Ausblenden mit Übergang: nach dem Fade noch einmal messen */
    function haengen(b) {
      if (ro) { ro.disconnect(); ro = null; }
      if (mo) { mo.disconnect(); mo = null; }
      if (banner) { banner.removeEventListener('transitionend', bald); }
      banner = b;
      if (!b) { return; }
      if (window.ResizeObserver) { ro = new ResizeObserver(bald); ro.observe(b); }
      if (window.MutationObserver) {
        mo = new MutationObserver(spaeter);
        mo.observe(b, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
        if (b.parentElement) { mo.observe(b.parentElement, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] }); }
      }
      b.addEventListener('transitionend', bald);
    }
    function messen() {
      plan = 0;
      var b = document.querySelector(COOKIE_SEL);
      if (b !== banner) { haengen(b); }
      var h = 0;
      if (b) {
        var vh = window.innerHeight || html.clientHeight;
        var r = b.getBoundingClientRect(), cs = window.getComputedStyle(b);
        if (r.width > 0 && r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05
          && r.top < vh && r.bottom > vh - 40) {
          h = Math.ceil(vh - r.top);
          if (h > vh * 0.5) { h = 0; } /* Vollbild-Dialog: Leiste nicht darüber schieben */
          var kn = document.querySelector('.rb-lsp-sticky__knopf'), kr = kn ? kn.getBoundingClientRect() : null;
          if (kr && kr.width > 0 && (r.right <= kr.left || r.left >= kr.right)) { h = 0; } /* 07.10.: Desktop-Banner links, Knopf rechts — nicht verdeckt, nicht verschieben */
        }
      }
      if (h !== letzt) { letzt = h; html.style.setProperty('--rb-cookie-h', h + 'px'); }
    }
    if (window.MutationObserver) { new MutationObserver(bald).observe(document.body, { childList: true, subtree: true }); }
    window.addEventListener('resize', bald);
    messen();
  }

  function start() {
    groessenwahl();
    zeichne();
    schwebeleiste();
    cookieAbstand();
    licht();
    zoom();
    farbwechselVorladen();
    beobachte();
    document.addEventListener('change', function () { window.requestAnimationFrame(zeichne); });
    window.setTimeout(function () { groessenwahl(); zeichne(); schwebeleiste(); beobachte(); }, 900);
  }
  /* Theme-Editor: Nach dem Bearbeiten rendert Shopify eine Sektion neu — neue Knoten ohne Handler.
     Alle Schritte sind über data-rb-bereit idempotent; beobachte() hängt sich an ein neues id-Feld. */
  document.addEventListener('shopify:section:load', function () {
    groessenwahl(); zeichne(); schwebeleiste(); licht(); farbwechselVorladen(); beobachte();
    /* Kopplung nach dem Neurendern gescheitert → Theme-Gruppe wieder zeigen, Karten aus */
    if (alle('[data-rb-groessenwahl]').some(function (w) { return w.getAttribute('data-rb-bereit') !== 'ja'; })) {
      document.documentElement.classList.remove('rb-g-js');
    }
  });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
}());
